"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _cccisdDetectClickLocation = _interopRequireDefault(require("cccisd-detect-click-location"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _Report = _interopRequireDefault(require("./Report"));
var _DownloadText = _interopRequireDefault(require("./DownloadText"));
var _style = _interopRequireDefault(require("./style.css"));
var _table = _interopRequireDefault(require("cccisd-icons/table2"));
var _filePdf = _interopRequireDefault(require("cccisd-icons/file-pdf"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Exports = function Exports(props) {
  var assignment = props.assignment,
    surveyHandles = props.surveyHandles,
    typeFilter = props.typeFilter,
    filter = props.filter,
    elementIcons = props.elementIcons,
    downloadCsv = props.downloadCsv;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    show = _useState2[0],
    setShow = _useState2[1];
  var clickedOutside = function clickedOutside() {
    setShow(false);
  };
  var renderDropDown = function renderDropDown() {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].exportMenu
    }, /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement("a", {
      onClick: downloadCsv
    }, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_table["default"], null), " ", /*#__PURE__*/_react["default"].createElement("span", null, "Download CSV"))), /*#__PURE__*/_react["default"].createElement(_DownloadText["default"], {
      type: "SPS",
      assignment: assignment,
      surveyHandles: surveyHandles,
      typeFilter: typeFilter,
      filter: filter
    }), /*#__PURE__*/_react["default"].createElement(_DownloadText["default"], {
      type: "SAS",
      assignment: assignment,
      surveyHandles: surveyHandles,
      typeFilter: typeFilter,
      filter: filter
    }), /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
      trigger: /*#__PURE__*/_react["default"].createElement("a", null, /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement(_filePdf["default"], null), " ", /*#__PURE__*/_react["default"].createElement("span", null, "Codebook PDF"))),
      size: "large",
      render: function render(_ref) {
        var closeModal = _ref.closeModal;
        return /*#__PURE__*/_react["default"].createElement(_Report["default"], {
          closeModal: closeModal,
          assignment: assignment,
          surveyHandles: surveyHandles,
          typeFilter: typeFilter,
          filter: filter,
          elementIcons: elementIcons
        });
      }
    })));
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].exports
  }, /*#__PURE__*/_react["default"].createElement(_cccisdDetectClickLocation["default"], {
    clickedOutside: clickedOutside,
    additionalOutsideTest: function additionalOutsideTest(e) {
      return !e.composedPath().find(function (n) {
        return n.className === 'modal-content';
      });
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-secondary",
    onClick: function onClick() {
      setShow(!show);
    }
  }, "Exports ", /*#__PURE__*/_react["default"].createElement("span", {
    className: _style["default"].caret
  })), show && renderDropDown()));
};
var _default = exports["default"] = Exports;